module.exports = __webpack_public_path__ + "img/gofoDownload.94be985f.svg";